import React, { useState } from "react";
import styles from "./FeedListItem.module.css";
import PropTypes from "prop-types";
import FeedTemplateIcon from "../FeedTemplateIcon";
import Button from "../Button";
import BannerItem from "../BannerItem";
import CloneToAUIcon from "../../assests/w_logo_au.png";
import ConfirmationDialog from "../ConfirmationDialog";
import FeedConfigBar from "../FeedConfigBar";
import FeedItem from "../FeedItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone, faRetweet } from "@fortawesome/free-solid-svg-icons";
import FeedItemModal from "../FeedItemModal";
import { CSSTransition } from "react-transition-group";
import dayjs from "dayjs";
import CloseDialog from "../CloseDialog";

/**
 * View. A list item that allows you to view, edit, or clone a feed.
 */

export function FeedListItem({
  feedItem,
  setFeedItem,
  onClone,
  onCloneAU,
  onEdit,
  onSync,
}) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // Add a check to confirm whether the content should even be previewed in the first place
  const isPreviewable =
    feedItem?.type === "Standard Content" ||
    feedItem?.type === "Standing Order";

  const handleOnCloneAU = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsOpen(false);
    setIsDialogOpen(false);
  };

  const handleConfirmDialog = () => {
    onCloneAU(feedItem);
    setIsDialogOpen(false);
    setIsOpen(true);
  };
  const STATUS_MAP = {
    0: "Unpublished",
    1: "Published",
    2: "Archived",
    3: "Storaged",
  };
  return (
    <div className={styles.container}>
      <div className={styles["left-content"]}>
        <div className={styles["icons-container"]}>
          <FeedTemplateIcon
            feedTemplateType={feedItem.type}
            iconSize={"36px"}
          />

          <div className={styles["title-config"]}>
            <h5 className={styles.title}>
              {feedItem.options.title}{" "}
              <div className={styles.red}>
                {feedItem.options.isEditingDraft && " | DRAFT VERSION"}
              </div>
            </h5>

            <FeedConfigBar
              publishStatus={
                STATUS_MAP[feedItem.options.status] || "Unpublished"
              }
              date={dayjs(feedItem.options.availableOn).format("YYYY-MM-DD")}
              signal={feedItem.options.priority}
              pinLevelPermissions={feedItem.options.pinLevelPermissions}
              platforms={feedItem.options.platforms}
            />
          </div>
        </div>

        {feedItem.type === "Banner" ? (
          <div className={styles["banner-item"]}>
            <BannerItem bannerSrc={feedItem.imgSrc} align="center" />
          </div>
        ) : (
          <div
            className={styles["feed-item-container"]}
            // Only apply onClick to content that should be previewed at all
            onClick={() => {
              if (isPreviewable) setIsModalOpen(true);
            }}
          >
            <div className={styles["feed-item"]}>
              <FeedItem feedItem={feedItem} />
            </div>
          </div>
        )}
      </div>

      <div className={styles["button-container"]} onClick={setFeedItem}>
        <div className={styles["button-items"]}>
          <button
            onClick={() => {
              onClone(feedItem.options.id, feedItem.type);
            }}
            className={styles["clone-button"]}
          >
            <FontAwesomeIcon
              icon={faClone}
              className={styles["clone-icon"]}
              size="xs"
            />
          </button>
        </div>
        <div className={styles["button-items"]} onClick={handleOnCloneAU}>
          <button className={styles["flag-button"]}>
            <img
              src={CloneToAUIcon}
              alt="Clone Item AU"
              className={styles["flag-icon"]}
            />
          </button>
        </div>
        <div className={styles["button-items"]}>
          <Button
            // onClick={() => onEdit(1234, feedItem.type)}
            onClick={() => {
              // console.log(feedItem);
              onEdit(feedItem.options.id, feedItem.type);
            }} // Update to use the actual ID
            text="Edit"
            className={styles["edit-button"]}
          />
        </div>
        {feedItem?.options?.syncFeedId && (
          <>
            <div className={styles["button-items"]}>
              <button
                onClick={() => onSync(feedItem)}
                className={styles["sync-button"]}
              >
                <div className={styles["inside-sync-button"]}>
                  <FontAwesomeIcon
                    icon={faRetweet}
                    className={styles["sync-icon"]}
                    size="lg"
                  />
                  <span className={styles.auID}>
                    {feedItem?.options?.syncFeedId}
                  </span>
                </div>
              </button>
            </div>
          </>
        )}
      </div>

      <ConfirmationDialog
        isVisible={isDialogOpen}
        onConfirmation={handleConfirmDialog}
        onDismiss={() => {
          setIsDialogOpen(false);
        }}
        confirmationText={
          "You are about to CLONE this feed item to AU Production as Unpublished. Continue?"
        }
      />

      <CSSTransition
        classNames={{
          enter: styles["fade-enter"],
          exit: styles["fade-exit"],
          enterActive: styles["fade-enter-active"],
          exitActive: styles["fade-exit-active"],
        }}
        addEndListener={(node, done) => {
          node.addEventListener("transitionend", done, false);
        }}
        in={isModalOpen}
        unmountOnExit
      >
        {/* {console.log("feedItem for Modal:", feedItem)} */}
        {/* Configure FeedItemModal for state to address errors with children */}
        {(state) => (
          <FeedItemModal
            // isOpen={isModalOpen ? "open" : "close"}
            isOpen={isModalOpen} // isModalOpen is already a boolean, no need to pass a string check here
            setIsOpen={() => setIsModalOpen(!isModalOpen)}
            feedItem={feedItem}
          />
        )}
      </CSSTransition>
    </div>
  );
}

// FeedListItem.propTypes = {
//   //Function that fires if the feedItem prop changes.
//   setFeedItem: PropTypes.func,
//   //Function that fires if the clone button is clicked.
//   onClone: PropTypes.func,
//   //Function that fires if the clone to AU button is clicked.
//   onCloneAU: PropTypes.func,
//   //Function that fires if the edit button is clicked.
//   onEdit: PropTypes.func,
//   //Function that fires if the sync button is clicked.
//   onSync: PropTypes.func,
//   /**
//    * String that states the type of feed template.
//    */
//   feedItem: PropTypes.PropTypes.oneOfType([
//     /**
//      * Standard Content Object
//      */
//     PropTypes.shape({
//       type: "Standard Content",
//       options: PropTypes.shape({
//         title: PropTypes.string,
//         permission: PropTypes.arrayOf(PropTypes.string),
//         checkedDiamonds: PropTypes.arrayOf(PropTypes.string),
//         incompatiblePlatforms: PropTypes.arrayOf(PropTypes.string),
//         publishStatus: PropTypes.oneOf([
//           "Unpublished",
//           "Published",
//           "Archived",
//           "Storaged",
//         ]),
//         publishDate: PropTypes.shape({
//           date: PropTypes.string,
//           time: PropTypes.string,
//           prioritye: PropTypes.string,
//         }),
//         removalDate: PropTypes.shape({
//           date: PropTypes.string,
//           time: PropTypes.string,
//         }),
//         removalDateAction: PropTypes.oneOf(["Unpublished", "Archived"]),
//         approvalStatus: PropTypes.oneOf([
//           "Management Approved",
//           "Let Diamonds Approve",
//         ]),
//       }),
//       information: PropTypes.object,
//       content: PropTypes.arrayOf(
//         PropTypes.arrayOf(
//           PropTypes.shape({
//             type: PropTypes.oneOf([
//               "text",
//               "image",
//               "divider",
//               "media",
//               "cms",
//               "bsm",
//             ]),
//           })
//         )
//       ),
//     }),

//     /**
//      * Standing Order
//      */
//     PropTypes.shape({
//       type: "Standing Order",
//       options: PropTypes.object,
//       information: PropTypes.object,
//       content: PropTypes.arrayOf(
//         PropTypes.arrayOf(
//           PropTypes.shape({
//             type: PropTypes.oneOf([
//               "text",
//               "image",
//               "divider",
//               "media",
//               "cms",
//               "bsm",
//             ]),
//           })
//         )
//       ),
//     }),

//     /**
//      * Banner
//      */
//     PropTypes.shape({
//       type: "Standard Content",
//       information: PropTypes.object,
//     }),
//   ]),

//   id: PropTypes.number,
//   auId: PropTypes.number,
// };

// Rebuild propTypes to correct typos, clean up logic, match correct types, etc.
FeedListItem.propTypes = {
  setFeedItem: PropTypes.func,
  onClone: PropTypes.func.isRequired,
  onCloneAU: PropTypes.func,
  onEdit: PropTypes.func.isRequired,
  onSync: PropTypes.func,
  feedItem: PropTypes.shape({
    type: PropTypes.string.isRequired,
    options: PropTypes.shape({
      title: PropTypes.string.isRequired,
      permission: PropTypes.arrayOf(PropTypes.string),
      checkedDiamonds: PropTypes.arrayOf(PropTypes.string),
      incompatiblePlatforms: PropTypes.arrayOf(PropTypes.string),
      publishStatus: PropTypes.string,
      publishDate: PropTypes.shape({
        date: PropTypes.string,
        time: PropTypes.string,
        priority: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
      removalDate: PropTypes.shape({
        date: PropTypes.string,
        time: PropTypes.string,
      }),
      removalDateAction: PropTypes.string,
      approvalStatus: PropTypes.string,
    }),
    information: PropTypes.object,
    auId: PropTypes.number,
  }).isRequired,
};
